import { css } from "@emotion/react";
import React from "react";
import { formatTimeToKorean12Hour } from "@src/util/formatTimeToKorean12Hour";
interface SentMessageProps {
    message: string;
    createdAt: string;
    isReadByOpponent?: boolean;
    showReadStatus?: boolean;
}

const SentMessage = ({ message, createdAt, isReadByOpponent, showReadStatus }: SentMessageProps) => {
    return (
        <div css={SentMessageBox}>
            <div className="time">
                {showReadStatus && !isReadByOpponent && <span className="read">1</span>}
                {formatTimeToKorean12Hour(createdAt)}
            </div>
            <div className="message">{message}</div>
        </div>
    );
};

export default SentMessage;

const SentMessageBox = css`
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 4px;
    margin-top: 6px;
    .time {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 10px;
        color: #888;
        min-width: fit-content;

        .read {
            text-align: right;
            color: #fff300;
        }
    }

    .message {
        font-size: 15px;
        color: #fff;
        background-color: #2275ee;
        padding: 10px;
        border-radius: 14px;
        line-height: 1.5;
    }
`;
